import React from 'react';
import { componentService } from 'js/services/component.service';

export const PromotionCode = React.lazy(() => import(/* webpackChunkName: "promotion-code" */ './PromotionCode'));

componentService.registerPageComponents({ 'promotion-code': PromotionCode });
